import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const HeadSalesNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='headsales' />

export default HeadSalesNavItem